import { render, staticRenderFns } from "./developerConfig-table.vue?vue&type=template&id=a2e55c92&scoped=true"
import script from "./developerConfig-table.vue?vue&type=script&lang=js"
export * from "./developerConfig-table.vue?vue&type=script&lang=js"
import style0 from "./developerConfig-table.vue?vue&type=style&index=0&id=a2e55c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e55c92",
  null
  
)

export default component.exports